import React from 'react';

const WineClubCampaignCreatePage = React.lazy(() => import('pages/wine-club-campaigns/create'));
const WineClubCampaignDetailsPage = React.lazy(() => import('pages/wine-club-campaigns/details'));
const WineClubCampaignListPage = React.lazy(() => import('pages/wine-club-campaigns/list'));
const WineClubCampaignCheckoutPage = React.lazy(() => import('pages/wine-club-campaigns/checkout'));

export const publicDefinitions = [
  {
    path: 'checkout/:checkoutNanoID',
    component: <WineClubCampaignCheckoutPage />
  }
];

export const privateDefinitions = [
  {
    index: true,
    policies: [{ resource: 'wineClubsManagement', action: 'view' }],
    component: <WineClubCampaignListPage />
  },
  {
    path: 'new',
    policies: [{ resource: 'wineClubsManagement', action: 'update' }],
    component: <WineClubCampaignCreatePage />
  },
  {
    path: 'details/:wineClubCampaignID',
    policies: [{ resource: 'wineClubsManagement', action: 'view' }],
    component: <WineClubCampaignDetailsPage />
  }
];
